// Hello? What's all this jQuery? We'll have no libraries here!
// Are you vanilla? This is a vanilla file, for vanilla people! There's nothing for jQuery folk here!

// JS
import userAgentClasses from './modules/user-agent-classes.js';
import Glide from '@glidejs/glide';

// Modules.
import trackFocus from './modules/track-focus.js';
import skipLink from './modules/skip-link.js';
import {
	mainNavigationToggle,
	propertySearchToggle,
} from './modules/toggles.js';
import markHelpful from './modules/markHelpful.js';
import { bigPictureInit } from './modules/bigpicture.js';
import { glideInit } from './modules/glide.js';
import { tomSelectInit } from './modules/tom-select.js';
import accordionsInit from './modules/accordion.js';
import { listingVideoInit } from './modules/listing-video.js';
import {
	blogNavigationInit,
	searchNavigationInit,
	propertyNavigationInit,
} from './modules/post-navigation.js';
import { blogFilterInit } from './modules/blog-filter.js';
import { SubNavInit } from './modules/sub-nav.js';
import {
	propertyLoadMoreInit,
	propertyFilterPopout,
} from './modules/property-filter.js';
import areasDropdownInit from './modules/areas-dropdown.js';
import universitiesDropdownInit from './modules/universities-dropdown.js';
import modalFormPopup from './modules/modal-form.js';
import { lightboxInit } from './modules/lightbox.js';
import { homeHeroTabs } from './modules/home-hero-tabs.js';
import { ajaxPaginationInit } from './modules/ajax-pagination.js';
import { dataLayerInit, dataLayerScroll } from './modules/datalayer.js';
import modalInit from './modules/modal.js';
import propertySearch from './modules/property-search.js';
import { hydrateWishlistCards } from './modules/wishlist.js';
import { megaMenuInit } from './modules/mega-menu.js';
import { siteHeaderInit } from './modules/site-header.js';
import { default as developmentProperties } from './modules/development-properties.js';

// Run
userAgentClasses();

window.dataLayer = window?.dataLayer || [];
// Ready.
window.addEventListener('DOMContentLoaded', async function () {
	// Replace no-js with js on the root HTML element.
	document.documentElement.className =
		document.documentElement.className.replace(/\bno-js\b/g, '') + ' js ';
	trackFocus(document.body);
	skipLink();
	mainNavigationToggle();
	propertySearchToggle();

	// We load this earlier than Glide so the hydrated markup has any modules triggered
	await hydrateWishlistCards();

	glideInit();
	tomSelectInit();
	markHelpful();
	bigPictureInit();
	listingVideoInit();
	blogNavigationInit();
	searchNavigationInit();
	propertyNavigationInit();
	blogFilterInit();
	accordionsInit();
	SubNavInit();
	propertyLoadMoreInit();
	propertyFilterPopout();
	areasDropdownInit();
	universitiesDropdownInit();
	modalFormPopup();
	lightboxInit();
	homeHeroTabs();
	ajaxPaginationInit();
	dataLayerInit();
	modalInit();
	propertySearch();
	megaMenuInit();
	siteHeaderInit();
	developmentProperties();
});

// Scroll.
window.addEventListener('scroll', function () {
	dataLayerScroll();
});
